module.exports = __webpack_public_path__ + "static/media/icon_best.39692b58.png";